export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	PRODUCTS = 'product',
	PRODUCT_MODELS = 'product-models',
	ORDERS = 'orders',
	OFFERS = 'offers',
	COMPLAINTS = 'complaints',

	ADMINS = 'admins',
	LOGIN_HISTORY = 'login-history',
	COMPANIES = 'companies',
	CLIENTS = 'clients',
	MERCHANT = 'merchant',

	PRODUCT_TYPE_CATEGORIES = 'product-type-categories',
	PRODUCT_TYPES = 'product-types',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	COMPONENTS = 'components',

	CONTENT = 'content',
	NOTIFICATIONS = 'notifications',
	FILES = 'files',

	FILE_CATEGORIES = 'file-categories',

	ROLES = 'roles',
	CONTACTS = 'contacts',
}
